var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-widescreen"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('Alter')],1),_c('div',{staticClass:"column"},[_c('DoI')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }